<template>
  <crud-update
    :open="open"
    :loading="loading"
    :title="title"
    :errorMessage="errorMessage"
    @update="update"
    @close="$emit('close')"
  >
    <producto-form
      ref="form"
      operation="updating"
      v-model="form"
      :input-errors="inputErrors"
    />
  </crud-update>
</template>

<script>
import ProductoProvider from "../../../providers/ProductoProvider";

import { CrudUpdate } from "@dracul/common-frontend";
import ClientError from "@/errors/ClientError";

import ProductoForm from "../ProductoForm";

export default {
  name: "ProductoUpdate",

  components: { ProductoForm, CrudUpdate },

  props: {
    open: { type: Boolean, default: true },
    item: { type: Object, required: true },
  },

  data() {
    return {
      title: "producto.editing",
      errorMessage: "",
      inputErrors: {},
      loading: false,
      form: {
        id: this.item.id,
        marca: this.item.marca,
        modelo: this.item.modelo,
        tamanio: this.item.tamanio,
        nombre: this.item.nombre != null ? this.item.nombre : "",
        // Solo usar nombre automático si el producto lo tiene explícitamente en true.
        // Productos importados simples suelen no tener marca/modelo/tamaño y vienen sin este flag:
        // en ese caso dejamos el nombre manual tal como está.
        nombreAutogenerado: this.item.nombreAutogenerado === true,
        codigoBarras: this.item.codigoBarras,
        productoProveedorPrecioActivoId: this.item.productoProveedorPrecioActivo ? this.item.productoProveedorPrecioActivo.id : null,
        depositoInfo: (this.item.deposito && this.item.deposito.nombre) ? this.item.deposito.nombre : null,
        deposito: (this.item.deposito && this.item.deposito.id) ? this.item.deposito.id : null,
        precioCompra: this.item.precioCompra,
        codigoBarrasProveedor: this.item.codigoBarrasProveedor,
        stock: this.item.stock,
        stockAlerta: this.item.stockAlerta,
        fechaVencimiento: this.item.fechaVencimiento || null,
        descuentoProveedor: this.item.descuentoProveedor || 0,
        ivaPorcentaje: this.item.ivaPorcentaje || 0,
        porcentajeSobreCosto: this.item.porcentajeSobreCosto || 0,
        tipoRedondeo: this.item.tipoRedondeo != null ? this.item.tipoRedondeo : null,
        otrasCaracteristicas: this.item.otrasCaracteristicas || "",
      },
    };
  },
  methods: {
    async update() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      try {
        const form = this.$refs.form;
        const hasActivePpp = this.form.productoProveedorPrecioActivoId != null;
        const payload = {
          ...this.form,
          ...(hasActivePpp && {
            activePppPrecioCompra: form.precioCompraActivoEdit != null && form.precioCompraActivoEdit !== "" ? Number(form.precioCompraActivoEdit) : null,
            activePppDescuentoProveedor: form.descuentoProveedor != null && form.descuentoProveedor !== "" ? Number(form.descuentoProveedor) : null,
          }),
        };
        const r = await ProductoProvider.updateProducto(payload);
        if (r) {
          await form.savePendingListaOverrides();
          this.$emit("itemUpdated", r.data.productoUpdate);
          this.$emit("close");
        }
      } catch (error) {
        const clientError = new ClientError(error);
        this.inputErrors = clientError.inputErrors;
        if (error.graphQLErrors && error.graphQLErrors.length > 0) {
          this.errorMessage = error.graphQLErrors[0].message || clientError.i18nMessage;
        } else {
          this.errorMessage = clientError.i18nMessage;
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped></style>
